<app-alert-modal
  *ngIf="cs.isBrowser"
  #purchasePointsModalRef
  [headerLabel]="PURCHASE_POINTS_MODAL_TEXT.TITLE"
  [showConfirmationBtn]="false"
  [dynamicClass]="'purchase-points-modal'"
  [modalOptions]="{ class: 'modal-lg modal-dialog-centered purchase-points-modal-dialog' }"
>
  <div class="purchase-points-modal-content">
    <h5 class="purchase-points-modal-subtitle">
      {{ PURCHASE_POINTS_MODAL_TEXT.SUBTITLE }}
    </h5>

    <div *ngIf="isLoading" class="purchase-points-modal-loader">
      <app-loader></app-loader>
    </div>

    <div *ngIf="!isLoading" class="purchase-points-modal-options">
      <div
        *ngFor="let loyaltyPointsPackage of packages; trackBy: trackByPackage"
        class="purchase-points-modal-option"
      >
        <div class="purchase-points-modal-option-copy">
          <img
            class="purchase-points-modal-option-icon"
            [src]="neutralCoinIconSrc"
            [alt]="LOYALTY_POINTS_TEXT.COIN_ALT"
          />
          <div class="purchase-points-modal-option-label">
            {{ getPackageLabel(loyaltyPointsPackage) }}
            <span
              *ngIf="loyaltyPointsPackage.bonus > Application.ZERO"
              class="purchase-points-modal-option-bonus"
            >
              {{ loyaltyPointsPackage.bonus.toLocaleString() }} Bonus Points
            </span>
          </div>
        </div>

        <app-button
          [btnField]="getPackageButton(loyaltyPointsPackage)"
          (handleButtonClick)="handlePackageSelection(loyaltyPointsPackage)"
        >
          <app-price-display
            [price]="loyaltyPointsPackage.base_price"
            [rate]="loyaltyPointsPackage.exchange_rate_to_usd"
            [symbol]="loyaltyPointsPackage.currency_symbol"
            [localPrice]="loyaltyPointsPackage.price"
          ></app-price-display>
        </app-button>
      </div>
    </div>
  </div>
</app-alert-modal>
